<div id="wrapper">
    <!-- <app-navbar></app-navbar> -->
    <div class="navbar-custom">
        <div class="container-fluid">
            <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
                <li>
                    <button
                        class="button-menu-mobile waves-effect waves-light"
                        (click)="toggleSidebar()"
                    >
                        <i class="ri-menu-line"></i>
                    </button>
                </li>
                <li class="breadcrumb">
                    <span class="breadcrumb-item">
                        <a href="javascript:void(0)">PayEXAP</a>
                    </span>
                    <span class="px-2"
                        ><i class="ri-arrow-right-s-line"></i
                    ></span>
                    <span class="breadcrumb-item" aria-current="page">
                        <a routerLink="/invoices">Invoices</a>
                    </span>
                    <span class="px-2"
                        ><i class="ri-arrow-right-s-line"></i
                    ></span>
                    <span class="breadcrumb-item" aria-current="page">
                        <a routerLink="/saved-invoices">Saved Invoices</a>
                    </span>
                </li>
            </ul>
            <ul class="navbar-nav list-unstyled topnav-menu float-end">
                <li class="nav-item dropdown nav-user">
                    <span
                        class="pro-user-name ms-1 dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {{ displayName }}
                    </span>
                    <ul class="dropdown-menu">
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/vendor-profile"
                            >
                                <i class="ri-user-3-line"></i>
                                <span class="ml-2">Vendor Profile</span>
                            </a>
                        </li>
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/change-password"
                            >
                                <i class="ri-lock-2-line"></i>
                                <span class="ml-2">Change Password</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="accountLogout()">
                                <i class="ri-logout-box-line"></i>
                                <span class="ml-2"> Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>

    <app-sidebar></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12">
                            <div
                                *ngIf="sessionExpired"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                                <span class="relogin" (click)="accountLogout()"
                                    >Click here to LogIn</span
                                >
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <div class="pane-header">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h4 class="pt-2">
                                                    Saved Invoices
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="search-pane py-4">
                                        <div class="row">
                                            <div class="col-md-2 col-sm-4">
                                                <label
                                                    class="d-inline-flex align-items-center mb-3"
                                                >
                                                    <select
                                                        id="show-headers"
                                                        class="form-select form-select-sm mx-1"
                                                    >
                                                        <option value="5">
                                                            Invoice No.
                                                        </option>
                                                        <option value="10">
                                                            PO No.
                                                        </option>
                                                        <option value="15">
                                                            PO Amount
                                                        </option>
                                                    </select>
                                                </label>
                                            </div>
                                            <div class="col-md-4 col-sm-8">
                                                <div
                                                    class="input-group flex-nowrap"
                                                >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="search..."
                                                        aria-label="search"
                                                        aria-describedby="addon-wrapping"
                                                        [(ngModel)]="searchTerm"
                                                    />
                                                    <span
                                                        class="input-group-text"
                                                        id="addon-wrapping"
                                                        ><i
                                                            class="ri-search-line"
                                                        ></i
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <div
                                            class="loader text-center"
                                            *ngIf="loading"
                                        >
                                            <app-loader></app-loader>
                                        </div>

                                        <ng-container *ngIf="!loading">
                                            <div
                                                *ngIf="isEmpty"
                                                class="text-center py-5"
                                            >
                                                <img
                                                    src="assets/images/empty-state.png"
                                                    alt="No-data"
                                                />
                                                <h1 class="card-title my-2">
                                                    No Saved Invoices Available
                                                </h1>
                                                <p class="card-text">
                                                    There is no available data
                                                    to show yet
                                                </p>
                                            </div>
                                            <ng-container *ngIf="!isEmpty">
                                                <div
                                                    *ngIf="deleteSuccess"
                                                    class="alert alert-success text-center"
                                                    role="alert"
                                                >
                                                    Invoice successfully deleted
                                                </div>
                                                <table
                                                    aria-describedby="saved-invoices"
                                                    class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap"
                                                    data-page-size="5"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                scope="col"
                                                                [appSort]="invs"
                                                                data-order="desc"
                                                                data-name="invoice_number"
                                                            >
                                                                Invoice Number
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="invs"
                                                                data-order="desc"
                                                                data-name="po_number"
                                                            >
                                                                PO No.
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="invs"
                                                                data-order="desc"
                                                                data-name="invoice_amount"
                                                            >
                                                                Invoice Amount
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                [appSort]="invs"
                                                                data-order="desc"
                                                                data-name="po_currency"
                                                            >
                                                                Currency
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th>

                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngFor="
                                                                let invoice of invs
                                                            "
                                                        >
                                                            <tr>
                                                                <td>
                                                                    {{
                                                                        invoice.invoice_number
                                                                    }}
                                                                </td>

                                                                <td>
                                                                    {{
                                                                        invoice
                                                                            .items[0]
                                                                            .poNumber
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        invoice.invoice_amount
                                                                            | number
                                                                                : "1.2"
                                                                    }}
                                                                </td>
                                                                <td>INR</td>

                                                                <td
                                                                    class="action-td"
                                                                >
                                                                    <button
                                                                        *ngIf="
                                                                            invoice.email_address ===
                                                                            null
                                                                        "
                                                                        class="btn btn-outline-primary"
                                                                        (click)="
                                                                            editInvoice(
                                                                                invoice.irn
                                                                            )
                                                                        "
                                                                    >
                                                                        Continue
                                                                    </button>
                                                                    <button
                                                                        *ngIf="
                                                                            invoice.email_address !==
                                                                            null
                                                                        "
                                                                        class="btn btn-outline-primary"
                                                                        (click)="
                                                                            editInvoiceNonPo(
                                                                                invoice.irn
                                                                            )
                                                                        "
                                                                    >
                                                                        Continue
                                                                    </button>
                                                                    <button
                                                                        class="btn btn-outline-danger"
                                                                        (click)="
                                                                            initiateDelete(
                                                                                invoice.irn
                                                                            )
                                                                        "
                                                                    >
                                                                        Delete
                                                                        Invoice
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                    </tbody>
                                                    <tfoot></tfoot>
                                                </table>
                                            </ng-container>
                                        </ng-container>
                                        <div class="table-footer py-5">
                                            <div class="row">
                                                <div class="col-sm-5">
                                                    <label
                                                        class="d-inline-flex align-items-center mb-3"
                                                    >
                                                        Show
                                                        <select
                                                            id="demo-show-entries"
                                                            class="form-select form-select-sm mx-1"
                                                            [(ngModel)]="
                                                                pageSize
                                                            "
                                                            (ngModelChange)="
                                                                refreshInvoices()
                                                            "
                                                        >
                                                            <option
                                                                [ngValue]="10"
                                                            >
                                                                10
                                                            </option>
                                                            <option
                                                                [ngValue]="25"
                                                            >
                                                                25
                                                            </option>
                                                            <option
                                                                [ngValue]="50"
                                                            >
                                                                50
                                                            </option>
                                                            <option
                                                                [ngValue]="100"
                                                            >
                                                                100
                                                            </option>
                                                        </select>
                                                        entries
                                                    </label>
                                                </div>
                                                <div class="col-sm-7">
                                                    <div class="text-end">
                                                        <!-- Showing 1-5 of 15 entries -->
                                                        <ngb-pagination
                                                            class="justify-content: flex-end !important;"
                                                            [collectionSize]="
                                                                collectionSize
                                                            "
                                                            [(page)]="page"
                                                            [pageSize]="
                                                                pageSize
                                                            "
                                                            (pageChange)="
                                                                refreshInvoices()
                                                            "
                                                        >
                                                        </ngb-pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="confirmDelete">
                        <div class="loader-wrapper delete-invoice">
                            <div class="loader-content error">
                                <div class="loader-text">
                                    <p class="text-white">
                                        Are you sure you want to delete this
                                        Saved Invoice?
                                    </p>
                                </div>
                                <div class="loader-cta my-4">
                                    <button
                                        class="btn btn-outline-primary"
                                        (click)="cancelDelete()"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        class="btn btn-error"
                                        (click)="deleteSavedInvoice()"
                                    >
                                        Delete Invoice
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
